import { SensorUploadStatusEnum } from 'src/api'

export interface SensorUploadStatusMeta {
  label: string
  color: 'success' | 'warning' | 'error' | 'default'
  description?: string
}

export const getSensorUploadStatusMeta = (status?: SensorUploadStatusEnum | string | null): SensorUploadStatusMeta => {
  switch (status) {
    case SensorUploadStatusEnum.Success:
      return { label: 'Success', color: 'success' }
    case SensorUploadStatusEnum.ErrorsDetected:
      return { label: 'Errors detected', color: 'warning', description: 'Sensors were imported, but QR archive generation failed' }
    case SensorUploadStatusEnum.Failed:
      return { label: 'Failed', color: 'error' }
    default:
      return { label: status || '-', color: 'default' }
  }
}
